export const dateHelpers = {
  data() {
    return {
    }
  },
  methods: {
    getDiffNumberOfDays(start, end, needTitle = true) { 
      const date1 = new Date(start); 
      const date2 = new Date(end); 
      
      const oneDay = 1000 * 60 * 60 * 24; 
      
      const diffInTime = date2.getTime() - date1.getTime(); 
      const diffInDays = Math.round(diffInTime / oneDay); 
      
      if (needTitle) {
        return diffInDays + ' ' + this.dayTitle(diffInDays); 
      } 

      return diffInDays; 
    },

    dayTitle(number) {
      if (number > 10 && [11, 12, 13, 14].includes(number%100)) return 'дней';
      let last_num = number % 10;
      if (last_num == 1) return 'день';
      if ([2, 3, 4].includes(last_num)) return 'дня';
      if ([5, 6, 7, 8, 9, 0].includes(last_num)) return 'дней';
    },

    variantByTwoDays(plan, fact) {
      if (!plan) {
        return 'light';
      } else if (!fact) {
        return 'warning';
      }
      
      const diff = this.getDiffNumberOfDays(fact, plan, false);

      if (diff >= 0) {
        return 'success';
      }
      if (diff < 0) {
        return 'danger';
      }

      return '';
    }
  }
}